(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["products"]) return;
  try {
    

  $( '#products' )

    .slick(

      {

        mobileFirst : true,

        slidesToScroll : 2,

        slidesToShow : 2,

        arrows : false,

        dots : true,

        responsive : [

          {

            breakpoint : 992,

            settings : {

              slidesToScroll : 4,

              slidesToShow : 4,

              arrows : false,

              dots : true

            }

          }

        ]

      }

    );


  } catch(e) { console.error(e); }
})();
})();
